import React, { PropTypes, Component } from "react";
import { inject, observer } from "mobx-react";
import {Button, Col, Form, FormGroup, FormText, Input, Label, Row, Table, Modal, ModalBody, ModalFooter, ModalHeader, InputGroup, InputGroupAddon} from 'reactstrap';
import FontAwesome from 'react-fontawesome';
import DatePicker from 'react-datepicker';
import DataWrapper from "../../../principal/containers/DataWrapper";
import Select from "react-select";
import {createSelectOptions} from "../../../../utils/formatar";
import {getMotivoContratacaoById} from "../../../../utils/enums";
import {Validacao} from "../../../comum/components/Validacao";
import _ from 'lodash';
import FluxoSolicitacaoTAStore from "../stores/FluxoSolicitacaoTAStore";
import ParametrosGeraisStore from "../../../administracao/stores/ParametrosGeraisStore";
import {Redirect} from "react-router-dom";
import {FormWithActions} from "../../../comum/components/FormWithActions";
import {DetalhamentoSolicitante} from "../../comum/components/DetalhamentoSolicitante";
import {DetalhamentoEmpregadosSubstituidos} from "../../comum/components/DetalhamentoEmpregadosSubstituidos";
import {DetalhamentoIndicacoes} from "../../comum/components/DetalhamentoIndicacoes";
import {DetalhamentoContato} from "../../comum/components/DetalhamentoContato";
import {DetalhamentoCargo} from "../../comum/components/DetalhamentoCargo";
import {DetalhamentoJustificativaExcecao} from "../../comum/components/DetalhamentoJustificativaExcecao";
import {DetalhamentoDebito} from "../../comum/components/DetalhamentoDebito";
import {DetalhamentoLocais} from "../../comum/components/DetalhamentoLocais";
import {DetalhamentoJustificativa} from "../../comum/components/DetalhamentoJustificativa";
import {DetalhamentoPrazos} from "../../comum/components/DetalhamentoPrazos";
import {DetalhamentoPerfil} from "../../comum/components/DetalhamentoPerfil";
import {DetalhamentoCPFDiferente} from "../../solicitacao_ett/components/DetalhamentoCPFDiferente";
import {DetalhamentoDadosMOT} from "../../solicitacao_ett/components/DetalhamentoDadosMOT";
import {DetalhamentoSalarioDiferente} from "../../solicitacao_ett/components/DetalhamentoSalarioDiferente";
import {DetalhamentoAlterarDataInicio} from "../../solicitacao_ett/components/DetalhamentoAlterarDataInicio";
import {DetalhamentoContratosAnterioresEValidacoes} from "../../comum/components/DetalhamentoContratosAnterioresEValidacoes";
import {DadosTerminoAntecipadoForm} from "../components/DadosTerminoAntecipadoForm";
import {DetalhamentoProrrogacoesAnteriores} from "../../comum/components/DetalhamentoProrrogacoesAnteriores";
import {LoadingPanel} from "../../../comum/components/LoadingPanel";
import { DetalhamentoHistoricoFluxo } from "../../comum/components/DetalhamentoHistoricoFluxo";

@inject("store")
@DataWrapper
@observer
export class SolicitacaoTA extends Component {
    constructor(props) {
        super(props);
        this.state = this.props.store.appStore;
        this.loginStore = this.props.store.loginStore;
        this.formStore = this.props.store.formStore;
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
        this.validacaoStore = this.props.store.validacaoStore;
        this.modalStore = this.props.store.modalStore;
        this.loadingPanelStore = this.props.store.loadingPanelStore;


        this.parametrosGeraisStore = new ParametrosGeraisStore();

        this.controller = new FluxoSolicitacaoTAStore(this.parametrosGeraisStore, this.loginStore, this.tituloPaginaStore, this.validacaoStore, this.modalStore, this.loadingPanelStore);
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Solicitação término antecipado");

        const taskId = _.get(this.props, "match.params.taskIdBpm");
        const taskIdBpmSubstituicao = _.get(this.props, "match.params.taskIdBpmSubstituicao");
        const solicitacaoId = _.get(this.props, "match.params.solicitacaoId");
        const solicitacaoEttId =  _.get(this.props, "match.params.solicitacaoEttId");
        const solicitacaoSubstituicaoId = _.get(this.props, "match.params.substituicaoId");
        this.controller.carregarLista(taskId ? {
                id: taskId,
                tipo: "tarefa"
            } :
            {
                solicitacaoId: solicitacaoId,
                solicitacaoEttId: solicitacaoEttId,
                taskIdBpmSubstituicao: taskIdBpmSubstituicao,
                solicitacaoSubstituicaoId: solicitacaoSubstituicaoId,
                tipo: "solicitacao"}, false
        );

        this.parametrosGeraisStore.carregarLista();
    }

    static propTypes = {
        label: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.array,
            PropTypes.object,
        ])
    };

    render() {
        if (this.formStore.acaoEnviada) {
            return <Redirect to="/contratacoes-vigentes" />;
        } else {
            return this.renderForm();
        }
    }

    renderForm() {
        const desabilitarValidacao = this.validacaoStore.desabilitarValidacao

        return (
            <div>
                <div className="form-wrapper">
                    <LoadingPanel>
                        <div className="content-panel panel-sm">
                            <Form className="panel-form">
                                <FormWithActions controller={this.controller} taskId={_.get(this.props, "match.params.taskIdBpm")} solicitacaoExcecao={this.controller.isSolicitacaoExcecao}
                                             tarefa={this.controller.nomeTarefa} fluxo={this.controller.nomeFluxo} possiveisAcoes={["ANTECIPAR_TERMINO"]}
                                             error={this.formStore.submitted && !this.modalStore.exibirModal.aberto && !this.validacaoStore.isValidForm}>
                                    {this.controller.exibeJustificativaExcecao &&
                                        <DetalhamentoJustificativaExcecao />
                                    }
                                    <DetalhamentoSolicitante />
                                    <DetalhamentoContato desabilitarValidacao={desabilitarValidacao} />
                                    <DetalhamentoLocais />
                                    {this.controller.exibeDebito &&
                                        <DetalhamentoDebito />
                                    }
                                    <DetalhamentoJustificativa />
                                    <DetalhamentoEmpregadosSubstituidos />
                                    <DetalhamentoPrazos />
                                    <DadosTerminoAntecipadoForm />
                                    <DetalhamentoCargo />
                                    <DetalhamentoPerfil />
                                    {this.controller.exibeDetalhamentoDadosMOT &&
                                        <DetalhamentoDadosMOT desabilitarValidacao={desabilitarValidacao} />
                                    }
                                    <DetalhamentoProrrogacoesAnteriores titulo={"Prorrogações realizadas"} textoNenhumResultado={"Nenhuma prorrogação realizada"} />
                                    {this.controller.exibeDetalhamentoHistorico &&
                                        <DetalhamentoHistoricoFluxo />
                                    }
                                </FormWithActions>
                            </Form>
                        </div>
                    </LoadingPanel>
                </div>
            </div>
        )
    }
}